import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import StarIcon from '@mui/icons-material/Star';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Favorite } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';
import { RegistrationStatus } from '../../Account.model';
import { GameConfig } from '../../../Config.model';
import { PreRegistrations } from '../../../authentication/Authentication.model';

interface Props {
  gameConfig: GameConfig;
  gameImage: string;
  // TODO: Convert object to Map for easier access
  userPreRegistration: PreRegistrations[keyof PreRegistrations];
  isNew?: boolean;
}

export function GameCard({ gameConfig, gameImage, userPreRegistration, isNew }: Props): JSX.Element {
  const [preRegState, setPreRegState] = useState<RegistrationStatus>();

  const { t } = useTranslation();
  const match = useRouteMatch();

  const getUserPreRegistrationStatus = (): void => {
    const preRegId = gameConfig.preRegistration.id as keyof PreRegistrations[keyof PreRegistrations];
    if (!Object.keys(gameConfig.preRegistration).length) {
      setPreRegState(RegistrationStatus.UNAVAILABLE);
    } else if (!userPreRegistration?.[preRegId]?.status) {
      setPreRegState(RegistrationStatus.UNREGISTERED);
    } else {
      setPreRegState(userPreRegistration[preRegId].status as RegistrationStatus);
    }
  };
  useEffect(() => {
    getUserPreRegistrationStatus();
  }, [gameConfig, userPreRegistration]);

  return (
    <div key={gameConfig.id} className='game-img-wrap' data-cy={`games-${gameConfig.id}-button`}>
      <Link to={`${match.path}/games/${gameConfig.id}`}>
        <img className='game-img' src={gameImage} alt='game' />
        {isNew && (
          <>
            <div className={`game-new ${!gameConfig.preRegistration?.id ? 'pre-reg-disabled' : ''}`}>
              <span className='badge new-badge'>
                {t('account.my-account.games.new')}
              </span>
            </div>
          </>
        )}

        {preRegState !== RegistrationStatus.UNAVAILABLE && (
          <>
            <div className='game-status' data-cy={`${gameConfig.id}-game-registration-status`}>
              { preRegState === RegistrationStatus.UNREGISTERED
                  && <InfoIcon className='icon info' /> }

              { preRegState === RegistrationStatus.REGISTERED
                  && <CheckCircleIcon className='icon success' /> }

              { preRegState === RegistrationStatus.SELECTED_NO_CLAIM
                  && <CheckCircleIcon className='icon success' /> }

              { preRegState === RegistrationStatus.REFERRED
                  && <Favorite className='icon danger' /> }

              { preRegState === RegistrationStatus.SELECTED
                  && <StarIcon className='icon gold' /> }

              { preRegState === RegistrationStatus.GRANTED
                  && <AutoAwesomeIcon className='icon gold' /> }
              <span
                className='label'
                data-cy={`thumbnail-${gameConfig.id}-${preRegState}`}
              >
                {t(`account.my-account.earlyAccess.${preRegState}`)}
              </span>
            </div>
          </>
        )}
      </Link>
    </div>
  );
}
